import axios from 'axios';
import google from '../../../config/google';

const GEOCODE_URL = `https://maps.googleapis.com/maps/api/geocode/json`;

export const getGoogleMapCoordinatesByAddress = address => {
  return axios.get(GEOCODE_URL, {
    params: {
      address,
      key: google.apiKey
    }
  })
    .then(response => {
      try {
        return response.data.results[0].geometry.location;
      } catch (e) {
        throw new Error(e)
      }
    });
};
